module.exports = __webpack_public_path__ + "static/media/n_icon_goback.39323399.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/n_icon_goback.png
// module id = 430
// module chunks = 0 1